<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  nps: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();

const npsColor = score => {
  if (score === null || score === undefined) return 'text-n-slate-11';
  if (score >= 50) return 'text-teal-9';
  if (score >= 0) return 'text-amber-9';
  return 'text-ruby-9';
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
  >
    <div class="text-sm font-medium text-n-slate-11">
      {{ t('PAINEL.NPS.TITLE') }}
    </div>

    <div v-if="loading" class="h-8 w-16 rounded bg-n-slate-3 animate-pulse" />
    <template v-else-if="nps && nps.total_responses > 0">
      <div class="flex items-end gap-3">
        <span class="text-3xl font-bold" :class="npsColor(nps.nps_score)">
          {{ nps.nps_score }}
        </span>
        <span class="text-sm text-n-slate-10 mb-1">{{
          t('PAINEL.NPS.LABEL')
        }}</span>
      </div>
      <div class="text-xs text-n-slate-10">
        {{ t('PAINEL.NPS.RESPONSES', { count: nps.total_responses }) }}
        {{ t('PAINEL.NPS.AVG', { avg: nps.average_score }) }}
      </div>
      <div class="flex gap-2 text-xs mt-1">
        <span class="text-teal-9">{{
          t('PAINEL.NPS.PROMOTERS_PCT', { pct: nps.promoters_pct })
        }}</span>
        <span class="text-n-slate-9">{{
          t('PAINEL.NPS.PASSIVES_PCT', { pct: nps.passives_pct })
        }}</span>
        <span class="text-ruby-9">{{
          t('PAINEL.NPS.DETRACTORS_PCT', { pct: nps.detractors_pct })
        }}</span>
      </div>
    </template>
    <div v-else class="text-sm text-n-slate-9 italic">
      {{ t('PAINEL.NPS.EMPTY') }}
    </div>
  </div>
</template>
